"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypographyCSS = void 0;

var styled_components_1 = require("styled-components");

var theme_1 = require("../theme");

exports.TypographyCSS = (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  if (props.textAlign) {
    console.warn("DEPRECATED: TypographyCSS > props.textAlign");
    return "text-align: ".concat(props.textAlign, ";");
  }
}, function (props) {
  var _a, _b; // If a string
  // 1) Try pulling from theme


  if (props.color && ((_a = theme_1.theme.colors[props.color]) === null || _a === void 0 ? void 0 : _a[props.colorVariant || 500]) != null) {
    return "color: ".concat((_b = theme_1.theme.colors[props.color]) === null || _b === void 0 ? void 0 : _b[props.colorVariant || 500], ";");
  } // 2) Or just set the value


  if (typeof props.color === "string") {
    return "color: ".concat(props.color, ";");
  } // Otherwise default to Gray


  return "color: ".concat(theme_1.theme.colors.gray[500], ";");
}, function (props) {
  if (props.opacity) {
    console.warn("DEPRECATED: TypographyCSS > props.opacity");
    return "opacity: ".concat(props.opacity, ";");
  }
});